import {configureStore, combineReducers} from '@reduxjs/toolkit';
import thunk from 'redux-thunk';
import projectReducer from './project-slice';
import foldersReducer from './folders-slice';
import assetsReducer from './assets-slice';
import projectionsReducer from './projections-slice';
import settingsReducer from './settings-slice';
import cameraReducer from './camera-slice';

const appReducer = combineReducers({
  project: projectReducer,
  camera: cameraReducer,
  folders: foldersReducer,
  projections: projectionsReducer,
  settings: settingsReducer,
  assets: assetsReducer
});

const rootReducer = (state, action) => {
  const newProject = action.type === 'NEW';
  const loadConfig = action.type === 'LOAD';

  if (loadConfig) {
    state = action.payload;
  }

  if (newProject) {
    state = undefined;
  }

  let modified = appReducer(state, action);

  if (newProject || loadConfig) {
    modified = appReducer(state, {
      type: "project/refreshModified",
      payload: null
    });
  }

  return modified;
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: [thunk],
});